import React from "react";
import styled from "styled-components";
import { PALETTE } from "../../styles/palette";
import { Weather } from "../../types";

const StyledMiddle = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: ${PALETTE.BLACK} solid;
  border-width: 1.7px 0;
  /* gap: 32px; */
  padding: 96px 0;
`;

const StyledBottom = styled.section`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 45px 0;
`;

const StyledTempAndWind = styled.span`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const StyledCurTemperature = styled.h1`
  font-size: 9rem;
  font-family: "LeferiBaseType-Bold";
`;

const StyledPrecipitation = styled.span`
  font-size: 1.25rem;
`;

type TodayWeatherProps = {
  todayWeather: Weather;
};

export const TodayWeather = ({ todayWeather }: TodayWeatherProps) => {
  return (
    <div>
      <StyledMiddle>
        <StyledCurTemperature>
          {todayWeather.curTemperature}°
        </StyledCurTemperature>
        <StyledPrecipitation>
          {todayWeather.sky}
          {todayWeather.precipitationType &&
            "/" + todayWeather.precipitationType}
          {todayWeather.precipitation &&
            "/" + todayWeather.precipitation + "mm"}
        </StyledPrecipitation>
      </StyledMiddle>
      <StyledBottom>
        <StyledTempAndWind>
          <b>{todayWeather.maxTemperature}°C</b>
          {todayWeather.minTemperature}°C
        </StyledTempAndWind>
        <StyledTempAndWind>
          <b>강수확률 {todayWeather.precipitationPercentage}%</b>
          풍속 {todayWeather.minTemperature}km/h
        </StyledTempAndWind>
      </StyledBottom>
    </div>
  );
};
